import axios from "axios";
import { server } from "../../server";

// load user
export const loadUser = () => async (dispatch) => {
  try {
    dispatch({
      type: "LoadUserRequest",
    });
    const { data } = await axios.get(`${server}/user/getuser`, {
      withCredentials: true,
    });
    dispatch({
      type: "LoadUserSuccess",
      payload: data.user,
    });
  } catch (error) {
    const isAuthError = error.response?.status === 401 || error.response?.status === 403;
    const errorCode = error.response?.data?.code;
    const message = error.response?.data?.message || error.message;

    if (errorCode === "ACCOUNT_DELETED") {
      dispatch({
        type: "LoadUserFail",
        payload: message,
      });
      return { accountDeleted: true, message };
    }

    if (!isAuthError) {
      dispatch({
        type: "LoadUserFail",
        payload: message,
      });
    } else {
      dispatch({
        type: "LoadUserFail",
        payload: null,
      });
    }
    return { accountDeleted: false };
  }
};

// load seller
export const loadSeller = () => async (dispatch) => {
  try {
    dispatch({
      type: "LoadSellerRequest",
    });
    const { data } = await axios.get(`${server}/shop/getSeller`, {
      withCredentials: true,
    });
    dispatch({
      type: "LoadSellerSuccess",
      payload: data.seller,
    });
  } catch (error) {
    dispatch({
      type: "LoadSellerFail",
      payload: error.response?.data?.message || error.message,
    });
  }
};

// User update information — accepts (name, email, phoneNumber, ukaraNumber, password) or single object
export const updateUserInformation =
  (nameOrPayload, email, phoneNumber, ukaraNumber, password) => async (dispatch) => {
    try {
      const isObject = nameOrPayload && typeof nameOrPayload === "object" && !Array.isArray(nameOrPayload);
      const payload = isObject
        ? {
            name: nameOrPayload.name,
            email: nameOrPayload.email,
            phoneNumber: nameOrPayload.phoneNumber,
            ukaraNumber: nameOrPayload.ukaraNumber,
            password: nameOrPayload.password,
          }
        : {
            name: nameOrPayload,
            email,
            phoneNumber,
            ukaraNumber,
            password,
          };

      dispatch({
        type: "updateUserInfoRequest",
      });

      const { data } = await axios.put(
        `${server}/user/update-user-info`,
        payload,
        {
          withCredentials: true,
        }
      );
      dispatch({
        type: "updateUserInfoSuccess",
        payload: data.user,
      });
      return true;
    } catch (error) {
      dispatch({
        type: "updateUserInfoFailed",
        payload: error.response?.data?.message || error.message,
      });
      return false;
    }
  };

// update user address
export const updatUserAddress =
  (country, city, address1, address2, postCode, addressType, address3 = "") =>
  async (dispatch) => {
    try {
      dispatch({
        type: "updateUserAddressRequest",
      });

      const { data } = await axios.put(
        `${server}/user/update-user-addresses`,
        {
          country,
          city,
          address1,
          address2,
          address3,
          postCode,
          addressType,
        },
        { withCredentials: true }
      );

      dispatch({
        type: "updateUserAddressSuccess",
        payload: {
          successMessage: "User address updated succesfully!",
          user: data.user,
        },
      });
    } catch (error) {
    dispatch({
      type: "updateUserAddressFailed",
      payload: error.response?.data?.message || error.message,
    });
    }
  };

// delete user address
export const deleteUserAddress = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "deleteUserAddressRequest",
    });

    const { data } = await axios.delete(
      `${server}/user/delete-user-address/${id}`,
      { withCredentials: true }
    );

    dispatch({
      type: "deleteUserAddressSuccess",
      payload: {
        successMessage: "Address deleted successfully!",
        user: data.user,
      },
    });
  } catch (error) {
    dispatch({
      type: "deleteUserAddressFailed",
      payload: error.response?.data?.message || error.message,
    });
  }
};

// get all users --- admin
export const getAllUsers = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllUsersRequest",
    });

    const { data } = await axios.get(`${server}/user/admin-all-users`, {
      withCredentials: true,
    });

    dispatch({
      type: "getAllUsersSuccess",
      payload: data.users,
    });
  } catch (error) {
    dispatch({
      type: "getAllUsersFailed",
      payload: error.response?.data?.message || error.message,
    });
  }
};

// what is action in redux ?
// Trigger an event , and call reducer
// action is a plain object that contains information about an event that has occurred
// action is the only way to change the state in redux
// action is the only way to send data from the application to the store

// dispatch :- active action , (action trigger)
